import { useEffect, useState } from 'react';
import { LoadSceneEvent, WarsEvents, WarsScenes } from '@playroomkit/pr-wars/events';
import './LobbyControlsInstructions.css';
import ScalableWrapper from '@components/ScalableWrapper';
import View from '@components/View';
import { utils } from '@playroomkit/pr-wars/utils';
import { WebEngineEvents } from '@playroomkit/pr-webengine/events';

const LobbyControlsInstructions = () => {
    const [showInstructions, setShowInstructions] = useState<boolean>(false);

    useEffect(() => {

        const handleLoadSceneEvents = (event: Event) => {
            let e = event as LoadSceneEvent,
              display = e.sceneName === WarsScenes.Lobby;
            
            setShowInstructions(display);
            
        }

        const handleToggleUIEvent = (event: Event) => {
            if(showInstructions) {
                setShowInstructions(false);
            }
        }

        document.addEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvents);
        document.addEventListener(WebEngineEvents.ToggleUIEvent, handleToggleUIEvent);

        return () => {
            document.removeEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvents);
            document.removeEventListener(WebEngineEvents.ToggleUIEvent, handleToggleUIEvent);
        }

    }, [showInstructions])

    return (
    <>
        {showInstructions && (
            <View className="instructions-wrapper">
                <ScalableWrapper maintainAspectRatioBy="height" anchor="bottom-left">
                    <View className="instructions-container">
                        {!utils.isRunningInMobile() && (<View className="instructions">
                            Use [WASD] to move characters 
                        </View>)}
                    </View>
                </ScalableWrapper>
            </View>
        )}
    </>
    );
};

export default LobbyControlsInstructions;
